import React from "react";

import { Typography } from "clearsense-ui/components";

const HeaderRow = () => (
  <tr>
    <th className="w-1/4" />
    <th className="w-1/4 p-6 bg-green-100 border border-gray-300">
      <Typography className="text-center">Actual Positives</Typography>
    </th>
    <th className="w-1/4 p-6 bg-red-100 border border-gray-300">
      <Typography className="text-center">Actual Negatives</Typography>
    </th>
    <th className="w-1/4 p-6 bg-gray-100 border border-gray-300">
      <Typography className="text-center">Total</Typography>
    </th>
  </tr>
);

export default HeaderRow;
